import {BlobContent} from './BlobContent'

export default BlobContent
